import { render, staticRenderFns } from "./PazarAsnafHero.vue?vue&type=template&id=3f80af16&scoped=true"
import script from "./PazarAsnafHero.vue?vue&type=script&lang=js"
export * from "./PazarAsnafHero.vue?vue&type=script&lang=js"
import style0 from "./PazarAsnafHero.vue?vue&type=style&index=0&id=3f80af16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80af16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
